import { SessionStorageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
const LAST_ACTIVE_KEY = 'TWS_LAST_ACTIVE';
function isLastActiveTimeLongerThan(maxIdleTime) {
    const lastActive = SessionStorageService.getItem(LAST_ACTIVE_KEY);
    SessionStorageService.removeItem(LAST_ACTIVE_KEY);
    if (!lastActive) {
        return false;
    }
    const lastActiveDate = new Date(lastActive);
    const now = new Date();
    const difference = now.getTime() - lastActiveDate.getTime();
    return difference >= maxIdleTime;
}
function setLastActiveTime() {
    SessionStorageService.setItem(LAST_ACTIVE_KEY, new Date().toISOString());
}
export { isLastActiveTimeLongerThan, setLastActiveTime };
//# sourceMappingURL=active-time.js.map